export default __webpack_public_path__ + "static/media/white-logo.8f550308.svg";